export default __webpack_public_path__ + "static/media/bird_white_female.536286df.png";